import { makeAutoObservable, observable } from 'mobx';
import { RootStore } from '../../state/RootStore';

export class ApplicationStore {
  @observable public isLoading = true;
  @observable public isSidebarOpen = false;
  @observable public isCartOpen = false;
  private readonly rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  public getRootStore(): RootStore {
    return this.rootStore;
  }

  public setLoading(value: boolean): void {
    this.isLoading = value;
  }

  public openSidebar(): void {
    this.isSidebarOpen = true;
  }

  public closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  public toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  public openCart(): void {
    this.isCartOpen = true;
  }

  public closeCart(): void {
    this.isCartOpen = false;
  }

  public toggleCart(): void {
    this.isCartOpen = !this.isCartOpen;
  }

  public criticalError(message?: string): void {}
}
